import './LandingPage.css';
import NavBar from './components/NavBar';
import Timestamp from './components/Timestamp';
import Bumpups from './components/Bumpups';
import Footer from './components/Footer';

function LandingPage() {
  return (
    <div className="landing-page">
      <NavBar />
      <div className="landing-page__content">
        <h1>Hello Landing Page</h1>
        <p>Welcome to the basic landing page layout.</p>
  
        <Timestamp />
         <Bumpups />
      </div>
      <Footer />
    </div>
  );
}

export default LandingPage;
